import React, { Component } from "react";
// import { settingsStart, getSettingsSuccess, settingsFailure } from '../../../../../../../src/redux/actions/settings'

// Ajax Methods
import ajaxMethods from "../../../../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../../../../api/ajax-endpoints";

// Forms
import RepayForm from "./RepaymentChannelForms/RepayForm";
import RepaymentForm from "./RepaymentChannelForms/RepaymentForm";
import {
  RepaymentAccountColumns,
  reOrderTableData,
} from "../../../../../../redux/actions/loans";
import { appInsights } from "../../../../../../config/appInsights";

export default class RepaymentChannelSettings extends Component {
  //State
  state = {
    loading: false,
    repaymentChannelOptions: [],
    selectedRepaymentId: "",
    bankId: "",
    accountNumber: "",
    bankOptionsList: [],
    repayEdit: false,
    bankName: "",
    error: "",
    accountName: "",
    accountLoading: false,
    selectedRepaymentIdSearch: "",
    RepaymentChannelList: [],
    channelAccountsDetails: [],
    reOrderedTableData: [],
  };

  // Life Cycle Hooks
  componentDidMount() {
    this.getRepaymentChannels();
    this.getBankList();
  }

  // Component Methods
  editModeHandler = (target) => {
    this.setState({ bankId: "", accountNumber: "" });
    let selectedForm = target.dataset["form"];
    // if(this.state.selectedRepaymentId){
    //     this.getDisbursementChannelDetails()

    // }

    this.setState({
      [`${selectedForm}Edit`]: true,
    });
  };

  cancelUpdateHandler = (target) => {
    let selectedForm = target.dataset["form"];

    this.setState({
      [`${selectedForm}Edit`]: false,
      [`${selectedForm}FormCopy`]: this.state[`${selectedForm}Form`],
      accountName: "",
    });
  };

  handleRepaySelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      repayEdit: false,
    });
  };
  handleOptionSelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // fetch repayment channel list
  getRepaymentChannels = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_REPAYMENT_CHANNEL_LIST)
      .then((response) => {
        let RepaymentChannelLists = [];
        if (response.data.length > 0) {
          RepaymentChannelLists = [...response.data];
        } else {
          RepaymentChannelLists = [
            {
              code: 0,
              productCategoryName: "No Categories Yet",
            },
          ];
        }
        const RepaymentChannelListOption = RepaymentChannelLists.map(
          (ecosystem, index) => {
            const { id, channel_name } = ecosystem;
            return (
              <option key={index} id={id} value={id}>
                {channel_name}
              </option>
            );
          }
        );

        this.setState({
          repaymentChannelOptions: RepaymentChannelListOption,
          RepaymentChannelList: RepaymentChannelLists,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "RepaymentChannelSettings.js",
          },
        });
      });
  };

  // fetch accounts for a specific disburse channel
  getRepaymentChannelAccounts = () => {
    this.setState({
      loading: true,
      channelAccountsDetails: [],
      reOrderedTableData: [],
    });
    ajaxMethods
      .get(
        ajaxEndpoints.GET_REPAYMENT_ACCOUNTS +
          `?repayment_channel_id=${this.state.selectedRepaymentIdSearch}`
      )
      .then((response) => {
        this.setState({ loading: false });

        if (response.status_code === 200 || response.status_code === 201) {
          if (response.data) {
            this.setState({ channelAccountsDetails: response.data });
            const reOrderedTableData = reOrderTableData(
              RepaymentAccountColumns,
              response.data
            );

            this.setState({ reOrderedTableData: reOrderedTableData });
          } else {
            this.setState({ channelAccountsDetails: [] });
          }
        } else {
          this.setState({ channelAccountsDetails: [] });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "RepaymentChannelSettings.js",
          },
        });
      });
  };

  //get bank list
  getBankList = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_BANK_LIST)
      .then((response) => {
        if (response.status_code === 200 || response.status_code === 201) {
          let bankList = response.data;
          const bankOptionsList = bankList.map((data, index) => {
            return (
              <option value={data.id} key={index}>
                {data.name}
              </option>
            );
          });
          this.setState({ bankOptionsList: bankOptionsList });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "RepaymentChannelSettings.js",
          },
        });
      });
  };
  //create disbursement channel accounts
  onCreateRepaymentChannelAccount = () => {
    const { selectedRepaymentId, bankId, accountNumber, accountName } =
      this.state;
    const Repay = {
      repayment_channel_id: Number(selectedRepaymentId),
      bank_id: Number(bankId),
      account_number: accountNumber,
      account_name: accountName,
    };

    ajaxMethods
      .post(ajaxEndpoints.ADD_REPAYMENT_CHANNEL_ACCOUNT, Repay)
      .then((response) => {
        let message = "";
        if (
          response.status_code === 200 ||
          response.status === 200 ||
          response.data.status === 200
        ) {
          message = response.data.message;
          this.props.onSetToast("success", message);
          this.setState({ repayEdit: false });
        } else if (response.status === 400) {
          message = response.data.message;
          this.props.onSetToast("error", message);
        } else {
          this.props.onSetToast(
            "warning",
            "Unable to connect to Advancly services"
          );
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "RepaymentChannelSettings.js",
          },
        });
        //
        this.props.onSetToast(
          "warning",
          "Unable to connect to Advancly services"
        );
      });
  };
  // validate account number
  onAccountNumberInput = (e) => {
    this.setState({ error: false, accountName: "" });
    let number = e.target.value;
    if (this.state.bankId === "") {
      this.setState({ error: `Please select a bank` });
      return;
    }

    this.setState({ accountNumber: number }, () => {
      this.getBankCode();
      if (number.length === 10 && !this.state.accountLoading) {
        this.setState({ accountLoading: true });

        //validate account number and bank name
        let data = {
          bank_code: this.state.bankCode,
          bank_account_num: number,
        };
        this.validateAccount(data);
      }
    });
  };
  // fetch product category list
  getBankCode = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_BANK_LIST + `?bank_id=${this.state.bankId}`)
      .then((response) => {
        if (response.status_code === 200 || response.status_code === 201) {
          let res = response.data[0];
          this.setState({ bankCode: res.code });
        } else {
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "RepaymentChannelSettings.js",
          },
        });
      });
  };
  validateAccount = (data) => {
    ajaxMethods
      .post(ajaxEndpoints.VALIDATE_ACCOUNT_NUMBER, data)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          this.setState({
            accountName: response.data.bank_account_name,
            accountLoading: false,
          });
          // response.json()
          //   .then(res => {
          //   })
        } else if (response.status === 400) {
          this.setState({
            error: response.data.message,
            accountLoading: false,
          });
        }
        if (response.status >= 500) {
          this.setState({
            error: "Unable to connect to Advancly services.",
            accountLoading: false,
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "RepaymentChannelSettings.js",
          },
        });
      });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: false,
    });
  };

  render() {
    const { systemFormCopy } = this.state;

    return (
      <div className="GlobalSettings col-sm-12 mt-30">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <RepayForm
              inputs={systemFormCopy}
              onEditMode={this.editModeHandler}
              onCancelUpdate={this.cancelUpdateHandler}
              onInputChange={this.handleChange}
              repayEdit={this.state.repayEdit}
              repaymentChannelOptions={this.state.repaymentChannelOptions}
              selectedRepaymentId={this.state.selectedRepaymentId}
              bankId={this.state.bankId}
              error={this.state.error}
              accountLoading={this.state.accountLoading}
              accountName={this.state.accountName}
              accountNumber={this.state.accountNumber}
              bankOptionsList={this.state.bankOptionsList}
              handleOptionSelect={this.handleOptionSelect}
              handleRepaySelect={this.handleRepaySelect}
              onCreateRepaymentChannelAccount={
                this.onCreateRepaymentChannelAccount
              }
              onAccountNumberInput={this.onAccountNumberInput}
            />
          </div>
          <div className="col-lg-8 col-md-6 col-sm-12">
            <RepaymentForm
              selectedRepaymentIdSearch={this.state.selectedRepaymentIdSearch}
              handleOptionSelect={this.handleOptionSelect}
              RepaymentChannelLists={this.state.RepaymentChannelList}
              channelAccountsDetails={this.state.channelAccountsDetails}
              reOrderedTableData={this.state.reOrderedTableData}
              loading={this.state.loading}
              onSearch={this.getRepaymentChannelAccounts}
            />
          </div>
        </div>
      </div>
    );
  }
}
